import { config } from '../config'

export const getSignInUrl = () => {
  return `https://${config.auth.cognitoUserPoolDomain}.auth.${config.auth.cognitoUserPoolRegion}.amazoncognito.com/login?client_id=${config.auth.cognitoUserPoolClientId}&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2F${window.location.hostname}`
}
